import { createAction } from 'redux-act'

export const getEmployees = createAction('Get Employees Request')
export const getEmployeesSuccessful = createAction('Get Employees Request Success')
export const getEmployeesFailure = createAction('Get Employees Request Fail')

export const updateEmployee = createAction('Update Employee Request')
export const updateEmployeeSuccessful = createAction('Update Employee Request Success')
export const updateEmployeeFailure = createAction('Update Employee Request Fail')
